
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <!-- Filter bar — collapsible, toggled by main header filter button (consistent pattern) -->
    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select
            id="statusFilter"
            [(ngModel)]="selectedStatus"
            (ngModelChange)="onStatusFilterChange()"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredRecords"
      [loading]="loading"
      [paginator]="showPaginator"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable offboarding-collection-table no-column-lines">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="employeeName">
            Employee Name
            <p-sortIcon field="employeeName" />
          </th>
          <th pSortableColumn="resignDate">
            Resign Date
            <p-sortIcon field="resignDate" />
          </th>
          <th>Status</th>
          <th class="th-task-col">P&amp;C</th>
          <th class="th-task-col">IT</th>
          <th class="th-task-col">Q&amp;A</th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-record>
        <tr>
          <td class="td-truncate" [pTooltip]="getEmployeeDisplay(record)" tooltipPosition="top">
            {{ getEmployeeDisplay(record) }}
          </td>
          <td>{{ record.resignDate | date:'dd/MM/yyyy' }}</td>
          <td>
            <p-tag
              [value]="record.status"
              [severity]="record.status === 'Completed' ? 'success' : record.status === 'Cancelled' ? 'danger' : 'warn'" />
          </td>
          <td class="td-task-btn text-center">
            <p-tag value="P&amp;C" [severity]="isTaskCompleted(record, 'PnC') ? 'success' : 'warn'"
              [style]="{ cursor: 'pointer' }" (click)="openTaskDialog(record, 'PnC')"
              pTooltip="Manage P&C tasks" tooltipPosition="top" />
          </td>
          <td class="td-task-btn text-center">
            <p-tag value="IT" [severity]="isTaskCompleted(record, 'IT') ? 'success' : 'warn'"
              [style]="{ cursor: 'pointer' }" (click)="openTaskDialog(record, 'IT')"
              pTooltip="Manage IT tasks" tooltipPosition="top" />
          </td>
          <td class="td-task-btn text-center">
            <p-tag value="Q&amp;A" [severity]="record.exitQuestionnaire?.isCompleted ? 'success' : 'warn'"
              [style]="{ cursor: 'pointer' }" (click)="openQADialog(record)"
              pTooltip="Exit questionnaire" tooltipPosition="top" />
          </td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                icon="pi pi-eye"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="View"
                tooltipPosition="top"
                (onClick)="viewRecord(record)" />
              <!-- Cancel is a status change, not a delete — uses pi-ban so it is not
                   confused with the permanent delete button below. -->
              <p-button
                *ngIf="record.status === 'InProgress'"
                icon="pi pi-ban"
                [text]="true"
                severity="warn"
                size="small"
                pTooltip="Cancel"
                tooltipPosition="top"
                (onClick)="cancelRecord(record)" />
              <p-button
                *ngIf="record.status === 'Cancelled'"
                icon="pi pi-check"
                [text]="true"
                severity="success"
                size="small"
                pTooltip="Activate"
                tooltipPosition="top"
                (onClick)="activateRecord(record)" />
              <!-- Permanent delete: admin only, Completed/Cancelled records only. -->
              <p-button
                *ngIf="canDeleteRecord(record)"
                icon="pi pi-trash"
                [text]="true"
                severity="danger"
                size="small"
                pTooltip="Delete permanently"
                tooltipPosition="top"
                (onClick)="deleteRecord(record)" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="7" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No offboarding records found</p>
              <p class="empty-description">Submit an offboarding form to create a new record</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Legend -->
    <div class="legend-bar">
      <div class="legend-item">
        <span class="legend-dot legend-dot-completed"></span>
        <span>Completed</span>
      </div>
      <div class="legend-item">
        <span class="legend-dot legend-dot-incomplete"></span>
        <span>Incomplete</span>
      </div>
    </div>
  </div>
</div>

<!-- Offboarding Form Dialog -->
<p-dialog
  [visible]="displayFormDialog"
  (visibleChange)="displayFormDialog = $event"
  [header]="formEditMode ? 'Edit Offboarding' : 'New Offboarding'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">

      <div class="emp-section-title"><i class="pi pi-user-minus"></i> Offboarding Details</div>

      <div class="form-row two-columns">
        <div class="field" [class.field-invalid]="formSubmitted && !selectedEmployee">
          <label>Employee Name <span class="required-star">*</span></label>
          <p-select
            [options]="employees"
            [(ngModel)]="selectedEmployee"
            optionLabel="name"
            placeholder="Search and select employee"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            [disabled]="formEditMode"
            appendTo="body"
            autocomplete="off" />
          <small class="field-error" *ngIf="formSubmitted && !selectedEmployee">Employee is required</small>
        </div>

        <div class="field">
          <label>Resign Date</label>
          <input pInputText type="date" [(ngModel)]="resignDateStr" autocomplete="off" />
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label>Reason</label>
          <p-select
            [options]="reasons"
            [(ngModel)]="selectedReason"
            optionLabel="label"
            optionValue="value"
            placeholder="Select reason"
            appendTo="body" />
        </div>
        <div class="field">&nbsp;</div>
      </div>

      <div class="emp-section-title"><i class="pi pi-paperclip"></i> Attachment</div>

      <div class="form-row">
        <div class="field">
          <label>Resignation Letter / Document <span class="field-hint">(PDF, DOC, DOCX, PNG, JPG — max 10 MB)</span></label>
          <div class="cv-upload-zone" [class.cv-has-file]="formAttachmentUrl">
            <ng-container *ngIf="!formAttachmentUrl && !formAttachmentUploading">
              <label class="cv-upload-label" for="offboardFileInput">
                <i class="pi pi-upload"></i>
                <span>Click to upload</span>
              </label>
              <input id="offboardFileInput" type="file" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" style="display:none" (change)="onAttachmentSelected($event)" />
            </ng-container>
            <ng-container *ngIf="formAttachmentUploading">
              <i class="pi pi-spin pi-spinner"></i>
              <span>Uploading...</span>
            </ng-container>
            <ng-container *ngIf="formAttachmentUrl && !formAttachmentUploading">
              <i class="pi pi-file cv-file-icon"></i>
              <span class="cv-file-name">{{ formAttachmentName }}</span>
              <a [href]="formAttachmentUrl" target="_blank" class="cv-action-btn" pTooltip="Open" tooltipPosition="top">
                <i class="pi pi-external-link"></i>
              </a>
              <button type="button" class="cv-action-btn cv-remove-btn" pTooltip="Remove" tooltipPosition="top" (click)="removeAttachment()">
                <i class="pi pi-times"></i>
              </button>
            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideFormDialog()" severity="secondary" [outlined]="true"
        [disabled]="formLoading" />
      <p-button [label]="formEditMode ? 'Save' : 'Submit'" icon="pi pi-check" (onClick)="submitOffboarding()" severity="primary"
        [loading]="formLoading" [disabled]="formLoading || formAttachmentUploading" />
    </div>
  </ng-template>
</p-dialog>

<!-- Task Dialog (P&C / IT) -->
<p-dialog
  [visible]="displayTaskDialog"
  (visibleChange)="displayTaskDialog = $event"
  [header]="selectedRecord ? getDeptLabel(dialogDepartment || '') + ' Tasks — ' + selectedRecord.employeeName : 'Tasks'"
  [modal]="true" styleClass="dialog-lg" [dismissableMask]="true" [style]="{ width: '600px' }">

  <div *ngIf="selectedRecord" style="padding: 0.5rem 0;">
    <!-- Group by department when viewing all -->
    <ng-container *ngIf="!dialogDepartment">
      <div *ngFor="let dept of ['PnC', 'IT']" style="margin-bottom:1rem;">
        <h4 style="margin:0 0 0.5rem;font-size:0.85rem;font-weight:600;color:var(--primary-color);border-bottom:2px solid var(--primary-color);padding-bottom:0.25rem;display:flex;align-items:center;gap:0.5rem;">
          <p-checkbox [binary]="true" [ngModel]="isDeptAllDone(dept)" (ngModelChange)="toggleDept(dept, $event)" />
          {{ getDeptLabel(dept) }}
          <span style="font-size:0.65rem;font-weight:400;color:var(--text-color-secondary);margin-left:auto;">Select all</span>
        </h4>
        <div *ngFor="let task of getTasksByDept(dept)" style="display:flex;align-items:center;gap:0.625rem;padding:0.4rem 0.25rem;">
          <p-checkbox [(ngModel)]="task.isCompleted" [binary]="true" [inputId]="task.id" />
          <label [for]="task.id" style="flex:1;font-size:0.875rem;cursor:pointer;" [style.text-decoration]="task.isCompleted ? 'line-through' : 'none'"
            [style.color]="task.isCompleted ? 'var(--text-color-secondary)' : 'var(--text-color)'">{{ task.taskName }}</label>
          <span *ngIf="task.isCompleted" style="font-size:0.7rem;font-weight:600;color:var(--green-600);"><i class="pi pi-check"></i> Done</span>
        </div>
      </div>
    </ng-container>

    <!-- Single department view -->
    <ng-container *ngIf="dialogDepartment">
      <div style="display:flex;align-items:center;gap:0.5rem;margin-bottom:0.75rem;">
        <p-checkbox [binary]="true" [ngModel]="isDeptAllDone(dialogDepartment!)" (ngModelChange)="toggleDept(dialogDepartment!, $event)" />
        <span style="font-size:0.8rem;color:var(--text-color-secondary);">Select all</span>
      </div>
      <div *ngFor="let task of dialogTasks" style="display:flex;align-items:center;gap:0.625rem;padding:0.5rem 0.25rem;">
        <p-checkbox [(ngModel)]="task.isCompleted" [binary]="true" [inputId]="task.id" />
        <label [for]="task.id" style="flex:1;font-size:0.875rem;cursor:pointer;" [style.text-decoration]="task.isCompleted ? 'line-through' : 'none'"
          [style.color]="task.isCompleted ? 'var(--text-color-secondary)' : 'var(--text-color)'">{{ task.taskName }}</label>
        <span *ngIf="task.isCompleted" style="font-size:0.7rem;font-weight:600;color:var(--green-600);"><i class="pi pi-check"></i> Done</span>
      </div>
    </ng-container>

    <div *ngIf="dialogTasks.length === 0" style="color:var(--text-color-secondary);font-style:italic;padding:1rem 0;">No tasks</div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="closeTaskDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveDeptTasks()" severity="primary" [loading]="savingTasks" />
    </div>
  </ng-template>
</p-dialog>

<!-- Q&A Dialog -->
<p-dialog
  [visible]="displayQADialog"
  (visibleChange)="displayQADialog = $event"
  [header]="selectedRecord ? 'Exit Questionnaire — ' + selectedRecord.employeeName : 'Exit Questionnaire'"
  [modal]="true" styleClass="dialog-lg" [dismissableMask]="true" [style]="{ width: '650px' }">

  <!-- Status indicators -->
  <div *ngIf="selectedRecord?.exitQuestionnaire" class="qa-status-bar">
    <div class="qa-status-item">
      <i class="pi pi-envelope" [style.color]="selectedRecord?.exitQuestionnaire?.emailSentDate ? 'var(--color-success, #22c55e)' : 'var(--text-color-secondary)'"></i>
      <span *ngIf="selectedRecord?.exitQuestionnaire?.emailSentDate" class="qa-status-sent">Email Sent</span>
      <span *ngIf="!selectedRecord?.exitQuestionnaire?.emailSentDate" class="qa-status-pending">Email Not Sent</span>
    </div>
    <div class="qa-status-item">
      <i class="pi" [class.pi-check-circle]="selectedRecord?.exitQuestionnaire?.isCompleted"
        [class.pi-clock]="!selectedRecord?.exitQuestionnaire?.isCompleted"
        [style.color]="selectedRecord?.exitQuestionnaire?.isCompleted ? 'var(--color-success, #22c55e)' : 'var(--color-warning, #f59e0b)'"></i>
      <span *ngIf="selectedRecord?.exitQuestionnaire?.isCompleted" class="qa-status-sent">Responded</span>
      <span *ngIf="!selectedRecord?.exitQuestionnaire?.isCompleted" class="qa-status-pending">No Response</span>
    </div>
  </div>

  <!-- Waiting state: employee hasn't completed the questionnaire yet — admin can only view -->
  <div *ngIf="!selectedRecord?.exitQuestionnaire?.isCompleted" class="qa-waiting-state" style="display:flex;flex-direction:column;align-items:center;gap:0.75rem;padding:2rem 1rem;text-align:center;">
    <i class="pi pi-clock" style="font-size:2.5rem;color:var(--color-warning, #f59e0b);"></i>
    <p style="margin:0;font-size:0.95rem;font-weight:600;color:var(--text-color);">Waiting for the employee response</p>
    <p style="margin:0;font-size:0.8rem;color:var(--text-color-secondary);max-width:420px;line-height:1.5;">
      The employee will receive a unique link by email and submit their answers through the questionnaire page. You can review them here once submitted.
    </p>
  </div>

  <!-- Read-only responses: employee has submitted — admin can only view -->
  <div *ngIf="selectedRecord?.exitQuestionnaire?.isCompleted && qaAnswers.length" style="padding: 0.5rem 0;">
    <div *ngFor="let qa of qaAnswers; let i = index" class="qa-answer-block qa-answered">
      <label class="qa-question-label">
        <span class="qa-question-num">{{ i + 1 }}</span>
        {{ qa.question }}
      </label>
      <div class="qa-answer-display" style="background:var(--surface-100, #f1f5f9);border:1px solid var(--surface-200, #e2e8f0);border-radius:6px;padding:0.625rem 0.75rem;font-size:0.875rem;color:var(--text-color);white-space:pre-wrap;line-height:1.5;min-height:2.5rem;">{{ qa.answer && qa.answer.trim() ? qa.answer : '—' }}</div>
    </div>
  </div>

  <div *ngIf="selectedRecord?.exitQuestionnaire?.isCompleted && !qaAnswers.length" style="color:var(--text-color-secondary);font-style:italic;padding:1rem 0;">No responses found</div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Close" icon="pi pi-times" (onClick)="closeQADialog()" severity="secondary" [outlined]="true" />
    </div>
  </ng-template>
</p-dialog>

<!-- View/Edit Offboarding Record Dialog -->
<p-dialog
  [visible]="displayViewDialog"
  (visibleChange)="displayViewDialog = $event"
  [header]="viewingRecord ? viewingRecord.employeeName + ' — Offboarding Details' : 'Offboarding Details'"
  [modal]="true" styleClass="dialog-lg" [dismissableMask]="true" [closable]="true" [style]="{ width: '650px' }">

  <div *ngIf="viewingRecord" class="employee-details-view">
    <!-- Header bar -->
    <div class="details-header-bar">
      <div class="details-name-block">
        <span class="details-name">{{ viewingRecord.employeeName }}</span>
        <span class="details-sub">{{ viewingRecord.companyName || '—' }}</span>
      </div>
      <p-tag [value]="viewingRecord.status" [severity]="viewingRecord.status === 'InProgress' ? 'warn' : viewingRecord.status === 'Completed' ? 'success' : 'secondary'" />
    </div>

    <!-- Details grid -->
    <div class="details-grid">
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-calendar"></i> Resign Date</span>
        <span class="detail-value">{{ formatDate(viewingRecord.resignDate) }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-info-circle"></i> Reason</span>
        <span class="detail-value">{{ viewingRecord.reason || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-check-circle"></i> P&C Tasks</span>
        <p-tag [value]="viewingRecord.pnCTasksCompleted ? 'Completed' : 'Pending'" [severity]="viewingRecord.pnCTasksCompleted ? 'success' : 'warn'" />
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-desktop"></i> IT Tasks</span>
        <p-tag [value]="viewingRecord.itTasksCompleted ? 'Completed' : 'Pending'" [severity]="viewingRecord.itTasksCompleted ? 'success' : 'warn'" />
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-comments"></i> Exit Q&A</span>
        <p-tag [value]="viewingRecord.exitQuestionnaire?.isCompleted ? 'Responded' : 'No Response'"
          [severity]="viewingRecord.exitQuestionnaire?.isCompleted ? 'success' : 'warn'" />
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-envelope"></i> Email Sent</span>
        <p-tag [value]="viewingRecord.exitQuestionnaire?.emailSentDate ? 'Sent' : 'Not Sent'"
          [severity]="viewingRecord.exitQuestionnaire?.emailSentDate ? 'success' : 'secondary'" />
      </div>
      <div class="detail-item detail-item--full">
        <span class="detail-label"><i class="pi pi-paperclip"></i> Attachment</span>
        <a *ngIf="viewingRecord.attachmentUrl" [href]="viewingRecord.attachmentUrl" target="_blank" class="detail-link">Open Attachment</a>
        <span *ngIf="!viewingRecord.attachmentUrl" class="detail-value">—</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Close" icon="pi pi-times" (onClick)="closeViewDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Edit" icon="pi pi-pencil" severity="info"
        (onClick)="editFromView()" />
    </div>
  </ng-template>
</p-dialog>
